<template>
  <b-container fluid>
    <div class="card-main">
      <!-- Botoes desktop -->
      <b-row class="mt-3 d-none d-md-block">
        <b-col md="12" sm="12">
          <b-button-group>
            <b-button
              variant="outline-primary btn-formacao"
              @click="_addFormacao()"
            >
              <b-icon icon="bookmarks-fill" aria-hidden="true"></b-icon>
              Adicionar Formação
            </b-button>

            <b-button variant="outline-primary btn-curso" @click="_addCurso()">
              <b-icon icon="award-fill" aria-hidden="true"></b-icon>
              Adicionar Cursos
            </b-button>

            <b-button
              variant="outline-primary btn-idioma"
              @click="_addIdioma()"
            >
              <b-icon icon="flag-fill" aria-hidden="true"></b-icon>
              Adicionar Idioma
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>

      <!-- Botoes mobile -->
      <b-row
        class="d-md-none"
        v-if="!is_formacao_edit && !is_curso_edit && !is_idioma_edit"
      >
        <b-col sm="12">
          <b-button
            variant="outline-primary btn-formacao"
            @click="_addFormacao()"
            block
          >
            <b-icon icon="bookmarks-fill" aria-hidden="true"></b-icon>
            Adicionar Formação
          </b-button>

          <b-button
            variant="outline-primary btn-curso"
            @click="_addCurso()"
            block
          >
            <b-icon icon="award-fill" aria-hidden="true"></b-icon>
            Adicionar Cursos
          </b-button>

          <b-button
            variant="outline-primary btn-idioma"
            @click="_addIdioma()"
            block
          >
            <b-icon icon="flag-fill" aria-hidden="true"></b-icon>
            Adicionar Idioma
          </b-button>
        </b-col>
      </b-row>

      <!-- //? Card List -->
      <div
        class="d-none d-md-block"
        v-if="!is_formacao_edit && !is_curso_edit && !is_idioma_edit"
      >
        <b-row>
          <b-col
            lg="3"
            sm="12"
            v-for="(rows, index) in user.formacao_lines"
            :key="rows.id"
          >
            <div class="card-main-formacoes formTypeFormacao adjustment-margin">
              <h6>
                <img src="../../assets/icon-college.png" />
                Formação
              </h6>
              <hr />
              <p>Curso: {{ rows.tp_formacao.nome }}</p>
              <p>
                Status: {{ rows.tp_concluso.nome }} {{ rows.ano_conclusao }}
              </p>
              <hr />
              <b-btn class="m-1" @click="_editFormacao(index)" variant="light">
                Editar
              </b-btn>
              <b-btn
                class="m-1"
                @click="_deleteFormacao(index)"
                variant="danger"
              >
                Excluir
              </b-btn>
            </div>
          </b-col>

          <b-col
            lg="3"
            sm="12"
            v-for="(rows, index) in user.curso_lines"
            :key="rows.id"
          >
            <div class="card-main-formacoes formTypeCurso adjustment-margin">
              <h6>
                <img src="../../assets/icon-book.png" />
                {{ rows.tp_formacao.nome }}
              </h6>
              <hr />
              <p>Curso: {{ rows.curso }}</p>
              <p>Status: {{ rows.tp_concluso.nome }}</p>
              <hr />
              <b-btn class="m-1" @click="_editCurso(index)" variant="light">
                Editar
              </b-btn>
              <b-btn class="m-1" @click="_deleteCurso(index)" variant="danger">
                Excluir
              </b-btn>
            </div>
          </b-col>

          <b-col
            lg="3"
            sm="12"
            v-for="(rows, index) in user.idioma_lines"
            :key="rows.id"
          >
            <div class="card-main-formacoes formTypeIdioma adjustment-margin">
              <h6>
                <img src="../../assets/icon-language.png" />
                Idiomas
              </h6>
              <hr />
              <p>Idioma: {{ rows.tp_idioma.nome }}</p>
              <p>Nível: {{ rows.tp_nivel.nome }}</p>
              <hr />
              <b-btn class="m-1" @click="_editIdioma(index)" variant="light">
                Editar
              </b-btn>
              <b-btn class="m-1" @click="_deleteIdioma(index)" variant="danger">
                Excluir
              </b-btn>
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- // Card List Celular -->
      <div
        class="d-md-none"
        v-if="!is_formacao_edit && !is_curso_edit && !is_idioma_edit"
      >
        <b-row class="mt-3">
          <b-col>
            <b-list-group>
              <!-- Grupo 1 -->
              <b-list-group-item
                class="formTypeFormacaoMobile"
                v-for="(rows, index) in user.formacao_lines"
                :key="rows.id"
              >
                <p><b>Formação</b></p>
                <p><b>Escola:</b> {{ rows.tp_formacao.nome }}</p>
                <p>
                  <b>Status:</b> {{ rows.tp_concluso.nome }}
                  {{ rows.ano_conclusao }}
                </p>
                <b-btn @click="_editFormacao(index)" variant="info" size="sm">
                  Editar
                </b-btn>
                <b-btn
                  class="m-1"
                  @click="_deleteFormacao(index)"
                  variant="danger"
                  size="sm"
                >
                  Excluir
                </b-btn>
              </b-list-group-item>

              <b-list-group-item
                class="formTypeCursoMobile"
                v-for="(rows, index) in user.curso_lines"
                :key="rows.id"
              >
                <p><b>Curso</b></p>
                <p><b>Nome:</b> {{ rows.nome }}</p>
                <p><b>Status:</b> {{ rows.tp_concluso.nome }}</p>
                <b-btn @click="_editCurso(index)" variant="info" size="sm">
                  Editar
                </b-btn>
                <b-btn
                  class="m-1"
                  @click="_deleteCurso(index)"
                  variant="danger"
                  size="sm"
                >
                  Excluir
                </b-btn>
              </b-list-group-item>

              <b-list-group-item
                class="formTypeIdiomaMobile"
                v-for="(rows, index) in user.idioma_lines"
                :key="rows.id"
              >
                <p><b>Idioma</b></p>
                <p><b>Língua:</b> {{ rows.tp_idioma.nome }}</p>
                <p><b>Nível:</b> {{ rows.tp_nivel.nome }}</p>
                <b-btn @click="_editIdioma(index)" variant="info" size="sm">
                  Editar
                </b-btn>
                <b-btn
                  class="m-1"
                  @click="_deleteIdioma(index)"
                  variant="danger"
                  size="sm"
                >
                  Excluir
                </b-btn>
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </div>

      <!-- //? Formação Modal -->
      <div v-if="is_formacao_edit">
        <b-row class="mt-3">
          <b-col lg="4" md="4" sm="12">
            <b-form-group label="Tipo Formação" label-for="input-37">
              <multiselect
                id="input-37"
                v-model="formacao.tp_formacao"
                :options="tipoFormacaoEscolaridade"
                :multiple="false"
                :preserve-search="true"
                placeholder="Selecione uma opção"
                track-by="nome"
                label="nome"
                :allow-empty="false"
                :select-label="'clique para selecionar'"
                :deselectLabel="''"
                :selectedLabel="'Selecionado'"
                required
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.nome }}</strong>
                </template>
              </multiselect>
              <div class="message">
                {{ validation.firstError("formacao.tp_formacao") }}
              </div>
            </b-form-group>
          </b-col>
          <b-col lg="2" md="2" sm="12">
            <b-form-group label="Turno" label-for="input-38">
              <multiselect
                id="input-38"
                v-model="formacao.tp_turno"
                :options="tipoFormacaoTurno"
                :multiple="false"
                :preserve-search="true"
                placeholder="Selecione uma opção"
                track-by="nome"
                label="nome"
                :allow-empty="false"
                :select-label="'clique para selecionar'"
                :deselectLabel="''"
                :selectedLabel="'Selecionado'"
                required
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.nome }}</strong>
                </template>
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <b-form-group label="Situação" label-for="input-39">
              <multiselect
                id="input-39"
                v-model="formacao.tp_concluso"
                :options="tipoFormacaoSituacao"
                :multiple="false"
                :preserve-search="true"
                placeholder="Selecione uma opção"
                track-by="nome"
                label="nome"
                :allow-empty="false"
                :select-label="'clique para selecionar'"
                :deselectLabel="''"
                :selectedLabel="'Selecionado'"
                required
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.nome }}</strong>
                </template>
              </multiselect>
              <div class="message">
                {{ validation.firstError("formacao.tp_concluso") }}
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="4" md="4" sm="12">
            <b-form-group
              label="Local/Escola/Faculdade/Entidade"
              label-for="input-40"
            >
              <b-form-input
                id="input-40"
                v-model="formacao.nome"
                :state="
                  validation.hasError('formacao.nome')
                    ? false
                    : formacao.nome != ''
                    ? true
                    : null
                "
              ></b-form-input>
              <div class="message">
                {{ validation.firstError("formacao.nome") }}
              </div>
            </b-form-group>
          </b-col>
          <b-col lg="4" md="4" sm="12">
            <b-form-group label="Curso" label-for="input-41">
              <b-form-input
                id="input-41"
                v-model="formacao.curso"
                :state="
                  validation.hasError('formacao.curso')
                    ? false
                    : formacao.curso != ''
                    ? true
                    : null
                "
              ></b-form-input>
              <div class="message">
                {{ validation.firstError("formacao.curso") }}
              </div>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <b-form-group
              label="Conclusão/Previsão (Mês/Ano)"
              label-for="input-42"
            >
              <b-form-input
                id="input-42"
                v-model="formacao.ano_conclusao"
                v-mask="'##/####'"
                :state="
                  validation.hasError('formacao.ano_conclusao')
                    ? false
                    : formacao.ano_conclusao.length >= 7
                    ? true
                    : null
                "
              ></b-form-input>
              <div class="message">
                {{ validation.firstError("formacao.ano_conclusao") }}
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" sm="12">
            <b-form-group
              label="Detalhes/Descrição do Curso"
              label-for="input-43"
            >
              <b-form-textarea
                id="input-43"
                v-model="formacao.detalhes"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-right">
            <b-button
              class="m-1"
              variant="warning"
              @click="_cancelEditFormacao()"
            >
              Cancelar
            </b-button>
            <b-button class="m-1" variant="success" @click="_salvarFormacao()">
              Salvar
            </b-button>
          </b-col>
        </b-row>
      </div>
      <!-- //? Formação Modal -->

      <!-- //? Modal Curso -->
      <div v-if="is_curso_edit">
        <b-row class="mb-4">
          <b-col lg="6" sm="12">
            <b-form-group label="Tipo Formação" label-for="input-44">
              <multiselect
                id="input-44"
                v-model="curso.tp_formacao"
                :options="tipoFormacaoCurso"
                :multiple="false"
                :preserve-search="true"
                placeholder="Selecione uma opção"
                track-by="nome"
                label="nome"
                :allow-empty="false"
                :select-label="'clique para selecionar'"
                :deselectLabel="''"
                :selectedLabel="'Selecionado'"
                required
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.nome }}</strong>
                </template>
              </multiselect>
              <div class="message">
                {{ validation.firstError("curso.tp_formacao") }}
              </div>
            </b-form-group>
          </b-col>
          <b-col lg="6" sm="12">
            <b-form-group label="Situação" label-for="input-45">
              <multiselect
                id="input-45"
                v-model="curso.tp_concluso"
                :options="tipoSituacaoCurso"
                :multiple="false"
                :preserve-search="true"
                placeholder="Selecione uma opção"
                track-by="nome"
                label="nome"
                :allow-empty="false"
                :select-label="'clique para selecionar'"
                :deselectLabel="''"
                :selectedLabel="'Selecionado'"
                required
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.nome }}</strong>
                </template>
              </multiselect>
              <div class="message">
                {{ validation.firstError("curso.tp_concluso") }}
              </div>
            </b-form-group>
          </b-col>
          <b-col lg="6" sm="12">
            <b-form-group label="Área do Curso" label-for="input-46">
              <multiselect
                id="input-46"
                v-model="curso.tp_area"
                :options="tipoAreaCurso"
                :multiple="false"
                :preserve-search="true"
                placeholder="Selecione uma opção"
                track-by="nome"
                label="nome"
                :allow-empty="false"
                :select-label="'clique para selecionar'"
                :deselectLabel="''"
                :selectedLabel="'Selecionado'"
                required
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.nome }}</strong>
                </template>
              </multiselect>
              <div class="message">
                {{ validation.firstError("curso.tp_area") }}
              </div>
            </b-form-group>
          </b-col>
          <b-col lg="6" sm="12">
            <b-form-group
              label="Local/Entidade/Palestrante"
              label-for="input-47"
            >
              <b-form-input
                id="input-47"
                v-model="curso.nome"
                :state="
                  validation.hasError('curso.nome')
                    ? false
                    : curso.nome != ''
                    ? true
                    : null
                "
              ></b-form-input>
              <div class="message">
                {{ validation.firstError("curso.nome") }}
              </div>
            </b-form-group>
          </b-col>
          <b-col lg="6" sm="12">
            <b-form-group label="Carga Horária" label-for="input-48">
              <b-form-input
                id="input-48"
                type="number"
                step="0.5"
                :state="
                  validation.hasError('curso.carga_horaria')
                    ? false
                    : curso.carga_horaria >= 0.5
                    ? true
                    : null
                "
                v-model="curso.carga_horaria"
              ></b-form-input>
              <div class="message">
                {{ validation.firstError("curso.carga_horaria") }}
              </div>
            </b-form-group>
          </b-col>
          <b-col lg="6" sm="12">
            <b-form-group
              label="Título (Curso/Palesta/Seminário/Outros)"
              label-for="input-49"
            >
              <b-form-input
                id="input-49"
                v-model="curso.curso"
                :state="
                  validation.hasError('curso.curso')
                    ? false
                    : curso.curso != ''
                    ? true
                    : null
                "
              ></b-form-input>
              <div class="message">
                {{ validation.firstError("curso.curso") }}
              </div>
            </b-form-group>
          </b-col>
          <b-col lg="12" sm="12">
            <b-form-group label="Detalhes/Descrição" label-for="input-50">
              <b-form-textarea
                id="input-50"
                v-model="curso.detalhes"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col lg="4" sm="12">
            <b-button class="m-1" variant="success" @click="_salvarCurso()">
              <b-icon-file-earmark-check></b-icon-file-earmark-check>
              Salvar
            </b-button>
            <b-button class="m-1" variant="warning" @click="_cancelEditCurso()">
              <b-icon-x-square></b-icon-x-square>
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </div>
      <!-- //? Curso Modal -->

      <!-- //? Idioma Modal -->
      <div v-if="is_idioma_edit">
        <b-row class="mb-4">
          <b-col lg="5" sm="12">
            <b-form-group label="Idioma" label-for="input-51">
              <multiselect
                id="input-51"
                v-model="idioma.tp_idioma"
                :options="tipoIdiomas"
                :multiple="false"
                :preserve-search="true"
                placeholder="Selecione uma opção"
                track-by="nome"
                label="nome"
                :allow-empty="false"
                :select-label="'clique para selecionar'"
                :deselectLabel="''"
                :selectedLabel="'Selecionado'"
                required
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.nome }}</strong>
                </template>
              </multiselect>
              <div class="message">
                {{ validation.firstError("idioma.tp_idioma") }}
              </div>
            </b-form-group>
          </b-col>
          <b-col lg="5" sm="12">
            <b-form-group label="Nível" label-for="input-52">
              <multiselect
                id="input-52"
                v-model="idioma.tp_nivel"
                :options="tipoIdiomaNivel"
                :preserve-search="true"
                placeholder="Selecione uma opção"
                track-by="nome"
                label="nome"
                :allow-empty="false"
                :select-label="'clique para selecionar'"
                :deselectLabel="''"
                :selectedLabel="'Selecionado'"
                required
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.nome }}</strong>
                </template>
              </multiselect>
              <div class="message">
                {{ validation.firstError("idioma.tp_nivel") }}
              </div>
            </b-form-group>
          </b-col>
          <b-col lg="4" sm="12">
            <b-button class="m-1" variant="success" @click="_salvarIdioma()">
              <b-icon-file-earmark-check></b-icon-file-earmark-check>
              Salvar
            </b-button>
            <b-button
              class="m-1"
              variant="warning"
              @click="_cancelEditIdioma()"
            >
              <b-icon-x-square></b-icon-x-square>
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </div>
      <!-- //? Idioma Modal -->
    </div>
  </b-container>
</template>
<script>
import SimpleVueValidation from "simple-vue-validator";
import CandidatoFormacao from "../../model/CandidatoFormacao";
import CandidatoIdioma from "../../model/CandidatoIdioma";
import CandidatoCurso from "../../model/CandidatoCurso";

const Validator = SimpleVueValidation.Validator;

SimpleVueValidation.extendTemplates({
  required: "Obrigatório",
  greaterThanOrEqualTo: "Infome/Escolha ao menos {0} opção.",
  length: "O tamanho mínimo é de {0} caracteres.",
  integer: "Infomre um valor inteiro (sem os centavos) - Somente o numero",
  greaterThan: "Informe um valor maior do que {0}.",
});

export default {
  data() {
    return {
      //? Formação
      tipoFormacaoEscolaridade: [
        { id: "0", nome: "Ensino Básico - Até 5º Ano" },
        { id: "1", nome: "Primário - Até 9 Ano" },
        { id: "2", nome: "Segundo Grau" },
        { id: "3", nome: "Segundo Grau - Técnico" },
        { id: "4", nome: "Técnico - Superior" },
        { id: "5", nome: "Curso Superior" },
        { id: "6", nome: "Pós-Graduação" },
        { id: "7", nome: "Mestrado" },
        { id: "8", nome: "Doutorado" },
      ],
      tipoFormacaoTurno: [
        { id: "M", nome: "Manhã" },
        { id: "T", nome: "Tarde" },
        { id: "N", nome: "Noite" },
        { id: "I", nome: "Integral" },
      ],
      tipoFormacaoSituacao: [
        { id: "0", nome: "Incompleto/Trancado" },
        { id: "1", nome: "Cursando" },
        { id: "3", nome: "Completo" },
      ],

      //? Idioma
      tipoIdiomas: [
        { id: "I", nome: "Ingles" },
        { id: "E", nome: "Espanhol" },
        { id: "F", nome: "Frances" },
        { id: "A", nome: "Alemão" },
        { id: "C", nome: "Mandarim(China)" },
        { id: "J", nome: "Japones" },
        { id: "O", nome: "Outros ( Especificar em Observações)" },
      ],
      tipoIdiomaNivel: [
        { id: "0", nome: "Básico" },
        { id: "1", nome: "Intermediário" },
        { id: "3", nome: "Fluente" },
        { id: "4", nome: "Nativo" },
      ],

      //? Cursos
      tipoFormacaoCurso: [
        { id: "0", nome: "Curso" },
        { id: "1", nome: "Palestra/Seminário" },
        { id: "2", nome: "Outros" },
      ],
      tipoSituacaoCurso: [
        { id: "0", nome: "Incompleto" },
        { id: "1", nome: "Cursando" },
        { id: "3", nome: "Completo" },
      ],
      tipoAreaCurso: [
        { id: "TI", nome: "Tecnologia Informação" },
        { id: "AD", nome: "Administração/FInanceira" },
        { id: "SG", nome: "Segurança no Trabalho" },
        { id: "OP", nome: "Operação de Máquinas e Equipamentos" },
        { id: "GQ", nome: "Gestão e Controle da Qualidade" },
        { id: "MK", nome: "Marketing - Marketing Digital" },
        { id: "VD", nome: "Comercial/Vendas" },
        { id: "OT", nome: "Outros" },
      ],

      //? Formação
      formacao: new CandidatoFormacao(),
      formacao_position_array: -1,
      is_formacao_edit: false,

      //? Idioma
      idioma: new CandidatoIdioma(),
      idioma_position_array: -1,
      is_idioma_edit: false,

      //? Cursos
      curso: new CandidatoCurso(),
      position_array_curso: -1,
      is_curso_edit: false,
    };
  },
  validators: {
    //?Formação
    "formacao.tp_formacao": function (value) {
      if (this.is_formacao_edit) {
        return Validator.value(value.nome).required();
      }
      return null;
    },
    "formacao.curso": function (value) {
      if (this.is_formacao_edit) {
        return Validator.value(value).required();
      }
      return null;
    },
    "formacao.nome": function (value) {
      if (this.is_formacao_edit) {
        return Validator.value(value).required();
      }
      return null;
    },
    "formacao.ano_conclusao": function (value) {
      if (this.is_formacao_edit) {
        return Validator.value(value).required();
      }
      return null;
    },
    "formacao.tp_concluso": function (value) {
      if (this.is_formacao_edit) {
        return Validator.value(value.nome).required();
      }
      return null;
    },

    //? Idiomas
    "idioma.tp_idioma": function (value) {
      if (this.is_idioma_edit) {
        return Validator.value(value.nome).required();
      }
      return null;
    },
    "idioma.tp_nivel": function (value) {
      if (this.is_idioma_edit) {
        return Validator.value(value.nome).required();
      }
      return null;
    },

    //?Cursos
    "curso.tp_formacao": function (value) {
      if (this.is_curso_edit) {
        return Validator.value(value.nome).required();
      }
      return null;
    },
    "curso.tp_concluso": function (value) {
      if (this.is_curso_edit) {
        return Validator.value(value.nome).required();
      }
      return null;
    },
    "curso.tp_area": function (value) {
      if (this.is_curso_edit) {
        return Validator.value(value.nome).required();
      }
      return null;
    },
    "curso.nome": function (value) {
      if (this.is_curso_edit) {
        return Validator.value(value).required();
      }
      return null;
    },
    "curso.carga_horaria": function (value) {
      if (this.is_curso_edit) {
        return Validator.value(value).required().integer().greaterThan(0);
      }
      return null;
    },
    "curso.curso": function (value) {
      if (this.is_curso_edit) {
        return Validator.value(value).required();
      }
      return null;
    },
  },

  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
  },

  created() {},

  methods: {
    //? Validate Tabs
    validateTab(edit) {
      let self = this;
      let status = false;

      if (!this.$refs[edit]) {
        this.$validate().then(function (success) {
          if (!success) {
            self.$swal({
              icon: "error",
              position: "top",
              title: "Não é possivel proseguir",
              html: "Antes de prosseguir verifique todos os campos obrigatórios",
              footer: "Preencha e valide todos os campos obrigatórios",
            });
            return status;
          }
        });
      }
      return status;
    },

    //? Formação
    _addFormacao() {
      if (this.is_idioma_edit) {
        this.validateTab(this.is_idioma_edit);
        return;
      }
      if (this.is_curso_edit) {
        this.validateTab(this.is_curso_edit);
        return;
      }

      this.is_idioma_edit = false;
      this.is_curso_edit = false;

      this.is_formacao_edit = true;
      this.formacao_position_array = -1;
      this.formacao = new CandidatoFormacao();
    },

    _salvarFormacao() {
      let self = this;
      this.$validate().then(function (success) {
        if (success) {
          if (self.formacao_position_array < 0) {
            self.user.formacao_lines.push(self.formacao);
          } else {
            self.user.formacao_lines[self.formacao_position_array] =
              self.formacao;
          }
          self.is_formacao_edit = false;
        }
      });
    },

    _cancelEditFormacao() {
      this.formacao = new CandidatoFormacao();
      this.is_formacao_edit = false;
    },

    _deleteFormacao(index) {
      let self = this;
      this.$swal({
        title: "Confirma a exclusão?",
        text: "Após a exclusão não será possivel recuperar os dados!",
        icon: "warning",
        showCloseButton: true,
        closeButtonAriaLabel: "Fechar",
        showCancelButton: true,
        confirmButtonText: "Sim, tenho certeza!",
        cancelButtonText: "Não, cancele!",
      }).then(function (isConfirm) {
        if (isConfirm.value) {
          self
            .$swal({
              title: "Excluido!",
              text: "item excluido com sucesso",
              icon: "success",
            })
            .then(function () {
              self.user.formacao_lines.splice(index, 1);
            });
        }
      });
    },

    _editFormacao(index) {
      this.is_idioma_edit = false;
      this.is_curso_edit = false;

      this.formacao = this.user.formacao_lines[index];
      this.formacao_position_array = index;
      this.is_formacao_edit = true;
    },

    //? Idioma
    _addIdioma() {
      if (this.is_formacao_edit) {
        this.validateTab(this.is_formacao_edit);
        return;
      }
      if (this.is_curso_edit) {
        this.validateTab(this.is_curso_edit);
        return;
      }

      this.is_formacao_edit = false;
      this.is_curso_edit = false;

      this.is_idioma_edit = true;
      this.idioma_position_array = -1;
      this.idioma = new CandidatoIdioma();
    },

    _salvarIdioma() {
      let self = this;

      this.$validate().then(function (success) {
        if (success) {
          if (self.idioma_position_array < 0) {
            self.user.idioma_lines.push(self.idioma);
          } else {
            self.user.idioma_lines[self.idioma_position_array] = self.idioma;
          }
          self.is_idioma_edit = false;
        }
      });
    },

    _cancelEditIdioma() {
      this.idioma = new CandidatoIdioma();
      this.is_idioma_edit = false;
    },

    _deleteIdioma(index) {
      let self = this;
      this.$swal({
        title: "Confirma a exclusão?",
        text: "Após a exclusão não será possivel recuperar os dados!",
        icon: "warning",
        showCloseButton: true,
        closeButtonAriaLabel: "Fechar",
        showCancelButton: true,
        confirmButtonText: "Sim, tenho certeza!",
        cancelButtonText: "Não, cancele!",
      }).then(function (isConfirm) {
        if (isConfirm.value) {
          self
            .$swal({
              title: "Excluido!",
              text: "item excluido com sucesso",
              icon: "success",
            })
            .then(function () {
              self.user.idioma_lines.splice(index, 1);
            });
        }
      });
    },

    _editIdioma(index) {
      this.is_formacao_edit = false;
      this.is_curso_edit = false;

      this.idioma = this.user.idioma_lines[index];
      this.idioma_position_array = index;
      this.is_idioma_edit = true;
    },

    //? Cursos
    _addCurso() {
      if (this.is_idioma_edit) {
        this.validateTab(this.is_idioma_edit);
        return;
      }
      if (this.is_formacao_edit) {
        this.validateTab(this.is_formacao_edit);
        return;
      }

      this.is_formacao_edit = false;
      this.is_idioma_edit = false;

      this.is_curso_edit = true;
      this.position_array_curso = -1;
      this.Curso = new CandidatoCurso();
    },

    _salvarCurso() {
      let self = this;
      this.$validate().then(function (success) {
        if (success) {
          if (self.position_array_curso < 0) {
            self.user.curso_lines.push(self.curso);
          } else {
            self.user.curso_lines[self.position_array_curso] = self.curso;
          }
          self.is_curso_edit = false;
        }
      });
    },

    _cancelEditCurso() {
      this.curso = new CandidatoCurso();
      this.is_curso_edit = false;
    },

    _deleteCurso(index) {
      let self = this;
      this.$swal({
        title: "Confirma a exclusão?",
        text: "Após a exclusão não será possivel recuperar os dados!",
        icon: "warning",
        showCloseButton: true,
        closeButtonAriaLabel: "Fechar",
        showCancelButton: true,
        confirmButtonText: "Sim, tenho certeza!",
        cancelButtonText: "Não, cancele!",
      }).then(function (isConfirm) {
        if (isConfirm.value) {
          self
            .$swal({
              title: "Excluido!",
              text: "item excluido com sucesso",
              icon: "success",
            })
            .then(function () {
              self.user.curso_lines.splice(index, 1);
            });
        }
      });
    },

    _editCurso(index) {
      this.is_formacao_edit = false;
      this.is_idioma_edit = false;

      this.curso = this.user.curso_lines[index];
      this.position_array_curso = index;
      this.is_curso_edit = true;
    },
  },
  beforeMount() {},
  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.message {
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}

.card-main-formacoes {
  border-radius: 5px;
  box-shadow: 0px 30px 40px -20px #c1c1c1;
  padding: 10px;
  background: #fff;
  margin-bottom: 5vh;
}

.formTypeFormacao {
  background-color: #388e3c;
  color: #fff;
  box-shadow: 0 4px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),
    0 1px 5px 0 rgb(0 0 0 / 20%);
}
.formTypeFormacaoMobile {
  border-bottom: 3px solid #388e3c;
}
.formTypeCurso {
  background-color: #3f51b5;
  color: #fff;
  box-shadow: 0 4px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),
    0 1px 5px 0 rgb(0 0 0 / 20%);
}
.formTypeCursoMobile {
  border-bottom: 3px solid #3f51b5;
}
.formTypeIdioma {
  background-color: #7b1fa2;
  color: #fff;
  box-shadow: 0 4px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),
    0 1px 5px 0 rgb(0 0 0 / 20%);
}
.formTypeIdiomaMobile {
  border-bottom: 3px solid #7b1fa2;
}

.btn-formacao:hover {
  background-color: #388e3c;
  color: #fff;
}
.btn-formacao {
  border-color: #388e3c;
  color: #388e3c;
}

.btn-curso:hover {
  background-color: #3f51b5;
  color: #fff;
}
.btn-curso {
  border-color: #3f51b5;
  color: #3f51b5;
}

.btn-idioma:hover {
  background-color: #7b1fa2;
  color: #fff;
}
.btn-idioma {
  border-color: #7b1fa2;
  color: #7b1fa2;
}
</style>
